export default "__VITE_ASSET__CWL75je3__"